'use strict';

import $ from 'jquery';
import { defaultOptions, tabbedMenuModifier } from '../tippy-util';
import {getOptionsFromDataset} from "../../../util/dom";

/**
 * @param {JQuery} $trigger
 * @param {JQuery} $triggerTarget
 * @param {JQuery} $appendTo
 * @param {JQuery} $container
 * @param {JQuery} $content
 * @param menuDirection
 * @param {Partial<import('tippy.js').Props>} options
 */
export default async ($trigger, $triggerTarget, $appendTo, $container, $content, menuDirection, options) => {

	// Import the tippy lib lazily
	const { default: tippy } = await import('tippy.js');

	// @ts-ignore
	const instance = tippy($trigger[0], {

		// Merge with default config
		...defaultOptions,

		...getOptionsFromDataset($trigger[0], 'tippy', true),
		...getOptionsFromDataset($triggerTarget[0], 'tippy', true),

		appendTo: $appendTo[0],
		content: (reference) => $content[0],
		placement: 'right-start',
		// trigger: 'click',
		popperOptions: {
			modifiers: [
				...defaultOptions.popperOptions.modifiers,
				{
					name: 'preventOverflow',
					enabled: true,
					options: {
						mainAxis: false,
						altAxis: true,
						boundary: $container[0],
						padding: 0,
					},
				},
				{
					name: 'applyDimensions',
					enabled: true,
					phase: 'beforeWrite',
					fn: (data) => {
						data.state.styles.popper.height = '100%';
						data.state.styles.popper.maxWidth = menuDirection === 'vertical' ? ('calc(100vw - ' + data.state.elements.reference.getBoundingClientRect().right + 'px)') : '100%';
					},
				},
				{
					name: 'applyTabbedMenu',
					enabled: true,
					phase: 'beforeWrite',
					fn: tabbedMenuModifier,
				},
			],
		},
		triggerTarget: $triggerTarget[0],
		onShow: (instance) => {
			$triggerTarget.closest('li').addClass('menu-tabbed__item--opened');
		},
		onHide: (instance) => {
			$triggerTarget.closest('li').removeClass('menu-tabbed__item--opened');
		},

		// Merge with provided options
		...options
	});

	$triggerTarget.data('instance', instance);

	return instance;
};
